import FieldStrategy from '../FieldStrategy';
import { generateDynamicFormModel, generateHtmlContent } from '@/views/fusion/investment/intelligence-create/tools/form';
import { clone, deepMerge } from '@/utils';
import { isNotNullAndUnDef } from '@/utils/is';
import { checkboxFilterNone, transformSelectedTimeToTimeSeries } from '@/tools/form';
import {
  CAMPAIGN_MODULE_KEY,
  CREATIVE_MODULE_KEY,
  TARGETING_MODULE_KEY,
  MATERIAL_MODULE_KEY,
  TITLE_MODULE_KEY,
} from '@/views/fusion/investment/intelligence-create/strategy/constants';
import { OPTIONS_TYPE, CHANNEL_INTERFACE_TYPE, TIME_PERIOD_LENGTH } from '@/enums';
import calculator from '@/utils/calculator';

const description = {
  label: '广告描述',
  type: 'input',
  props: {
    placeholder: '请输入广告描述',
    maxlength: 26,
    showWordLimit: true,
  },
  value: '',
  rules: [],
};

const product_description = {
  label: '推广产品描述',
  type: 'input',
  props: {
    placeholder: '请输入推广产品描述',
    maxlength: 15,
    showWordLimit: true,
  },
  value: '',
  rules: [],
};

const brand = {
  label: '广告品牌描述',
  type: 'input',
  props: {
    placeholder: '请输入广告品牌描述',
    maxlength: 10,
    showWordLimit: true,
  },
  value: '',
  rules: [],
};

const deep_link_url = {
  label: 'DeepLink地址',
  type: 'input',
  props: {
    placeholder: '请输入DeepLink地址，格式xx://xx',
  },
  value: '',
  rules: [],
};

/** 【创意组件】表单配置 */
const creative_components_config = {
  description,
  product_description,
  brand,
  deep_link_url,
};

/**
 * 小米策略类
 */
export default class XiaomiFieldStrategy extends FieldStrategy {
  /**
   * 获取差异化模块字段
   * @returns {Object}
   */
  getDifferentiatedFields() {
    return {
      campaign_config: {
        config: {
          delivery_form: {
            config: {
              delivery_platform_type: {
                value: '2',
                backup_value: '2',
              },
              delivery_content_id: {
                type: '',
                is_single_advertiser_assign: true,
                is_open: false,
                value: {
                  type_selection: [
                    { label: 'Android应用', value: '2' },
                  ],
                  result_map: {},
                },
                isPreview: false,
                rules: {
                  required: true,
                  trigger: ['change'],
                  validator: (_, value, callback) => {
                    if (Object.keys(value.result_map || {}).length) {
                      callback();
                    } else {
                      callback(new Error('请选择投放内容'));
                    }
                  },
                },
              },
              campaign_type: {
                label: '计划类型',
                type: 'radio-group',
                isButton: true,
                options: [
                  { label: '商店', value: 1 },
                  { label: '非商店', value: 2 },
                ],
                value: 2,
                backup_value: 2,
                rules: [
                  { required: true, message: '请选择计划类型', trigger: ['change'] },
                ],
              },
            },
          },
          site_form: {
            config: {
              site_set_type: {
                props: {
                  disabled: true,
                },
                value: 2,
              },
              site_sets: {
                hidden: false,
                props: {
                  max: 1,
                },
                value: ['3'],
                backup_value: ['3'],
                rules: [
                  { required: true, message: '请选择广告版位', trigger: ['change'] },
                ],
              },
              traffic_mode: {
                label: '流量优选',
                type: 'radio-group',
                isButton: true,
                options: [
                  { label: '开启', value: 1 },
                  { label: '关闭', value: 0 },
                ],
                value: 0,
              },
            },
          },
          budget_and_bid_form: {
            config: {
              daily_budget_type: {
                value: 'BUDGET_MODE_DAY',
                props: {
                  disabled: true,
                },
              },
              daily_budget: {
                hidden: false,
              },
              price_type: {
                options_map: {
                  cpc: [
                    { label: 'CPC', value: '2' },
                    { label: 'oCPC', value: '101' },
                  ],
                  cpd: [
                    { label: 'CPD', value: '3' },
                    { label: 'oCPD', value: '102' },
                  ],
                },
                value: '102',
              },
              auto_optimize: {
                label: '自动优化',
                type: 'radio-group',
                isButton: true,
                options: [
                  { label: '开启', value: 1 },
                  { label: '关闭', value: 0 },
                ],
                props: {
                  disabled: false,
                },
                value: 0,
              },
              delivery_policy: {
                label: '投放类型',
                type: 'radio-group',
                isButton: true,
                hidden: false,
                options: [
                  { label: '加速投放', value: 0 },
                  { label: '匀速投放', value: 1 },
                ],
                value: 1,
              },
              price_strategy: {
                hidden: true,
                value: '0',
              },
              convert_id: {
                hidden: true,
              },
              fusion__optimize_goal: {
                label: '优化目标',
                type: 'select',
                hidden: false,
                props: {
                  clearable: true,
                },
                options: [],
                value: '',
                backup_value: '',
                rules: [
                  { required: true, message: '请选择优化目标', trigger: ['change'] },
                ],
              },
              deep_convert_type: {
                hidden: true,
              },
              skip_one_stage: {
                label: '广告免一阶',
                type: 'radio-group',
                isButton: true,
                hidden: false,
                options: [
                  { label: '开启', value: 1 },
                  { label: '关闭', value: 0 },
                ],
                value: 1,
              },
              price: {
                hidden: false,
              },
              convert_goal_price: {
                label: '优化目标出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: undefined,
                rules: [
                  { required: true, message: '请输入优化目标出价', trigger: ['change'] },
                ],
              },
              ocpx_bid: {
                label: '优化ROI系数出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 3,
                  min: 0.001,
                },
                value: undefined,
                rules: [
                  { required: true, message: '请输入优化ROI系数出价', trigger: ['change'] },
                ],
              },
              deep_ocpx_bid: {
                label: '深度ROI系数出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 3,
                  min: 0.001,
                },
                value: undefined,
                rules: [
                  { required: true, message: '请输入深度ROI系数出价', trigger: ['change'] },
                ],
              },
            },
          },
        },
      },
      creative_config: {
        config: {
          content_form: {
            config: {
              delivery_mode: {
                label: '投放模式',
                type: 'radio-group',
                isButton: true,
                props: {
                  disabled: true,
                },
                options: [
                  { label: '组件化创意', value: OPTIONS_TYPE.UNLIMITED },
                  { label: '自定义创意', value: OPTIONS_TYPE.CUSTOM },
                ],
                value: OPTIONS_TYPE.CUSTOM,
              },
              creative_template_id: {
                label: '创意形式',
                type: 'radio-group',
                isBox: true,
                options: [],
                value: null,
                backup_value: null,
              },
              fusion__customized_url: {
                label: '落地页跳转类型',
                type: 'radio-group',
                isButton: true,
                hidden: true,
                options: [
                  { label: '应用详情页', value: 'APP_DETAIL_PAGE' },
                ],
                value: 'APP_DETAIL_PAGE',
                rules: [
                  { required: true, message: '请选择落地页跳转类型', trigger: ['change'] },
                ],
              },
            },
          },
          creative_components: {
            loading: false,
          },
        },
      },
      targeting_config: {
        config: {
          targeting_form: {
            config: {
              geo_location: {
                children: {
                  location_type: {
                    props: {
                      disabled: true,
                    },
                    value: 'CURRENT',
                  },
                },
              },
              age: {
                value: {},
                children: {
                  age_selection: {
                    label: '年龄',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '指定年龄段', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  age: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: [
                      { required: true, message: '请选择年龄段', trigger: ['change'] },
                    ],
                  },
                },
              },
              network: {
                label: '网络环境',
                type: 'checkbox-group',
                isButton: true,
                options: [],
                value: [OPTIONS_TYPE.UNLIMITED],
              },
              installation: {
                label: 'APP安装',
                type: 'radio-group',
                isButton: true,
                labelTips: generateHtmlContent({
                  content: [
                    '注意：',
                    '广告版位为通知栏时仅支持使用“已安装”定向',
                    '广告版位为开屏时仅支持使用“未安装”定向',
                  ],
                  is_index: false,
                }),
                options: [],
                value: OPTIONS_TYPE.UNLIMITED,
              },
            },
          },
        },
      },
      material_config: {
        config: {
          material_form: {
            config: {
              material: {
                props: {
                  type: 'image',
                  tempMaterial: null,
                },
                materialRestriction: [],
                material_type: null,
              },
            },
          },
        },
      },
    };
  }

  /**
   * 添加事件
   * @param {Object} config 模块配置
   * @param {Object} controller 控制器
   */
  addEvent(config, controller) {
    this.config = config;
    super.addEvent(config);
    const {
      campaign_config: {
        config: {
          delivery_form,
          site_form,
          schedule_form,
          budget_and_bid_form,
        },
      },
    } = config;

    const { delivery_platform_type, delivery_content_id, campaign_type } = delivery_form.config;
    const { site_sets } = site_form.config;
    const { time_period_type } = schedule_form.config;
    const {
      price_type,
      auto_optimize,
      convert_goal_price,
      price_strategy,
      fusion__optimize_goal,
      deep_convert_type,
      ocpx_bid,
      delivery_policy,
      skip_one_stage,
      price,
      deep_convert_price,
      deep_ocpx_bid,
    } = budget_and_bid_form.config;

    /**
     * 出价方式是ocpc或ocpd
     * ocpc: '101'
     * ocpd: '102'
     * @returns {boolean}
     */
    const isOcpx = () => {
      return price_type.value === '101' || price_type.value === '102';
    };

    /**
     * 设置优化目标出价可见性
     * 满足以下条件即可设置可见
     * 1、出价方式为ocpc（'101'）或ocpd(’102‘)
     * 2、优化目标必须为以下这几个：
     * - 24h新增付费：'10023'
     * - 24h注册：'10034'
     * - 付费次数：'10055'
     * @returns {void}
     */
    const setConvertGoalPriceVisible = () => {
      const is_match = ['10023', '10034', '10055'].some((value) => fusion__optimize_goal.value === value);
      convert_goal_price.hidden = !(is_match && isOcpx());
    };

    /**
     * 设置优化ROI系数出价可见性
     * 满足以下条件即可设置可见
     * 1、出价方式为ocpc（'101'）或ocpd(’102‘)
     * 2、优化目标必须为以下这几个：
     * - 24h新增ROI：'10022'
     * - 7日ROI：'10056'
     * @returns {void}
     */
    const setOcpxBidVisible = () => {
      const is_match = ['10022', '10056'].some((value) => fusion__optimize_goal.value === value);
      ocpx_bid.hidden = !(is_match && isOcpx());
    };

    /**
     * 设置广告免一阶可见性
     * 满足以下条件即可设置可见
     * 1、出价方式为ocpc（'101'）或ocpd(’102‘)
     * 2、自动优化为关闭状态
     * @returns {void}
     */
    const setSkipOneStageVisible = () => {
      const is_auto_optimize_close = auto_optimize.value === 0;
      skip_one_stage.hidden = !(is_auto_optimize_close && isOcpx());
    };

    /**
     * 设置深度优化出价可见性
     * 满足以下条件即可设置可见
     * 1、出价方式为ocpc（'101'）或ocpd(’102‘)
     * 2、深度优化目标等于付费次数：'10055'
     * @returns {void}
     */
    const setDeepConvertPriceVisible = () => {
      const is_match = deep_convert_type.value === '10055';
      deep_convert_price.hidden = !(is_match && isOcpx());
    };

    /**
     * 设置深度ROI系数出价可见性
     * 满足以下条件即可设置可见
     * 1、出价方式为ocpc（'101'）或ocpd(’102‘)
     * 2、深度优化目标必须在以下这几个：
     * - 24h新增ROI：'10022'
     * - 7日ROI：'10056'
     * @returns {void}
     */
    const setDeepOcpxBidVisible = () => {
      const is_match = ['10022', '10056'].some((value) => deep_convert_type.value === value);
      deep_ocpx_bid.hidden = !(is_match && isOcpx());
    };

    /**
     * 投放平台
     * 此处change事件是为了覆盖父类的change事件
     */
    delivery_platform_type.on = {
      change: () => {},
    };

    /** 投放内容 */
    delivery_content_id.on = {
      change: async() => {
        const is_change = JSON.stringify(delivery_content_id.value) !== JSON.stringify(delivery_content_id.backup_value);
        if (is_change) {
          delivery_content_id.backup_value = JSON.parse(JSON.stringify(delivery_content_id.value));
        }
      },
    };

    /** 计划类型 */
    campaign_type.on = {
      change: async() => {
        /** 计划类型是否是非商店 */
        const is_not_store = campaign_type.value === 2;

        /**
         * 满足以下条件时，广告预算与出价-投放类型可见
         * - 计划类型为非商店
         */
        delivery_policy.hidden = !is_not_store;

        if (campaign_type.value !== campaign_type.backup_value) {
          campaign_type.backup_value = campaign_type.value;

          /** 获取版位列表 */
          site_sets.options = await controller.getSiteSet({
            xiaomi_params: {
              filtering: {
                campaign_type: campaign_type.value,
              },
            },
          });

          /** 推荐版位值 */
          const RECOMMEND_ID = '35';
          /** 应用分发版位值 */
          const APP_DISTRIBUTION_ID = '3';

          /**
           * 设置默认选中的广告版位
           * @param {Array} options 广告版位选项
           * @param {string} target_id 目标版位ID
           * @returns {Array} 默认选中的广告版位值
           */
          const setDefaultSiteSet = (options, target_id) => {
            const is_match = options.some(({ value }) => target_id === value);
            return is_match ? [target_id] : [options[0].value];
          };

          /** 计划类型是否是商店 */
          const is_store = campaign_type.value === 1;

          /**
           * 设置默认选中的广告版位
           * 商店类型下：推荐
           * 非商店类型下：应用分发
           */
          const target_id = is_store ? RECOMMEND_ID : APP_DISTRIBUTION_ID;
          site_sets.value = setDefaultSiteSet(site_sets.options, target_id);
          site_sets.backup_value = [...site_sets.value];
          site_sets.on.change();
        }
      },
    };

    /** 广告版位 */
    site_sets.on = {
      change: async() => {
        if (!site_sets.value.length) {
          return;
        }

        if (site_sets.value[0] !== site_sets.backup_value[0]) {
          site_sets.backup_value = [...site_sets.value];
        }

        /**
         * 满足以下条件时，投放时间类型可见
         * - 广告版位不为【应用商店-开屏[33]】
         */
        time_period_type.hidden = !(!['33'].includes(site_sets.value[0]));
        time_period_type.on.change();

        /**
         * 1、支持的出价方式包括：CPC、CPD、oCPC、oCPD
         * 2、根据不同的广告版位适用不同的出价方式
         * CPC/oCPC：通知栏('32')、非商店-富媒体('36')、开屏('33')
         * CPD/oCPD：应用分发('3')、商店-富媒体('34')、推荐('35')
         */
        const is_cpc = ['32', '36', '33'].includes(site_sets.value[0]);

        price_type.options = price_type.options_map[is_cpc ? 'cpc' : 'cpd'];

        const is_match = price_type.options.some(({ value }) => price_type.value === value);
        !is_match && (price_type.value = price_type.options[1].value);
        price_type.on.change();
      },
    };

    /** 出价方式 */
    price_type.on = {
      change: () => {
        const is_cpc = price_type.value === '2';
        const is_cpd = price_type.value === '3';
        const is_match = is_cpc || is_cpd;
        /** 出价方式为CPC、CPD时自动优化默认置为'关闭'，不可修改 */
        auto_optimize.props.disabled = is_match;
        auto_optimize.value = is_match ? 0 : auto_optimize.value;
        auto_optimize.on.change();

        fusion__optimize_goal.hidden = is_match;
        fusion__optimize_goal.on.change();
      },
    };

    /** 自动优化 */
    auto_optimize.on = {
      change: () => {
        /** 自动优化是否开启状态 */
        const is_auto_optimize = auto_optimize.value === 1;

        /** 自动优化为开启时可见 */
        price_strategy.hidden = !is_auto_optimize;

        /**
         * 广告出价满足以下条件即可见
         * 1、自动优化为关闭时可见且必填
         */
        price.hidden = !!is_auto_optimize;
        setSkipOneStageVisible();
      },
    };

    /** 优化目标 */
    fusion__optimize_goal.on = {
      change: async() => {
        if (fusion__optimize_goal.value !== fusion__optimize_goal.backup_value) {
          fusion__optimize_goal.backup_value = fusion__optimize_goal.value;
          deep_convert_type.value = '';
        }

        /** 是否存在优化目标 */
        const is_has_optimize_goal = !!fusion__optimize_goal.value;
        /** 优化目标是否是24h注册 */
        const is_register = fusion__optimize_goal.value === '10034';

        setConvertGoalPriceVisible();
        setOcpxBidVisible();

        /**
         * 深度优化目标显示需要满足以下条件
         * 1、出价方式是oCPC（'101'）或oCPD（'102'）
         * 2、存在优化目标
         * 3、优化目标为24h注册
         */
        deep_convert_type.hidden = !(is_has_optimize_goal && is_register && isOcpx());
        deep_convert_type.on.change();
      },
    };

    /** 深度优化目标 */
    deep_convert_type.on = {
      change: () => {
        setDeepConvertPriceVisible();
        setDeepOcpxBidVisible();
      },
    };

    const {
      creative_config: {
        config: {
          content_form,
        },
      },
    } = config;
    const { creative_template_id } = content_form.config;

    /** 创意形式 */
    creative_template_id.on = {
      change: async() => {
        /** 获取创意动态组件 */
        if (creative_template_id.value !== creative_template_id.backup_value) {
          creative_template_id.backup_value = creative_template_id.value;
          const params = {
            filtering: {
              site_sets: site_sets.value,
            },
            xiaomi_params: {
              filtering: {
                delivery_platform_type: delivery_platform_type.value,
                creative_template_id: creative_template_id.value,
              },
            },
          };
          this.renderDynamicComponent({ config, params, controller });
        }
      },
    };

    const {
      targeting_config: {
        config: {
          targeting_form,
        },
      },
    } = config;
    const {
      age: {
        children: {
          age_selection,
          age,
        },
      },
      network,
    } = targeting_form.config;

    /** 年龄 */
    age_selection.on = {
      change: () => {
        const is_custom = age_selection.value === OPTIONS_TYPE.CUSTOM;
        age.hidden = !is_custom;
      },
    };

    /** 网络环境 */
    network.on = {
      change: () => {
        network.value = checkboxFilterNone(network.value, OPTIONS_TYPE.UNLIMITED);
      },
    };
  }

  /**
   * 获取覆盖字符对象
   * @returns {Object}
   */
  getDifferentiatedOverrides() {
    return {};
  }

  /**
   * 设置配置模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setFieldDataSources(config, controller) {
    try {
      await super.setFieldDataSources(config, controller);
      const {
        campaign_config: {
          config: {
            budget_and_bid_form,
          },
        },
      } = config;
      const { price_type, fusion__optimize_goal, deep_convert_type } = budget_and_bid_form.config;
      price_type.options = price_type.options_map['cpd'];
      fusion__optimize_goal.options = await controller.getConvertGoalEnums();
      deep_convert_type.options = await controller.getDeepConvertGoalEnums();
    } catch (error) {
      console.error(error);
      throw new Error('XiaomiFieldStrategy: setFieldDataSources fail');
    }
  }

  /**
   * 设置定向模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setTargetingDataSources(config, controller) {
    await super.setTargetingDataSources(config, controller);
    const {
      age: {
        children: {
          age,
        },
      },
      network,
      installation,
    } = config.targeting_config.config.targeting_form.config;

    /** 定向字典 */
    const targeting_dictionary = await controller.getTargetingDictionary(['age', 'network', 'installation']);

    /** 不限选项 */
    const unlimited_selection = { label: '不限', value: OPTIONS_TYPE.UNLIMITED };

    /** 年龄 */
    age.options = targeting_dictionary?.age || [];

    /** 网络环境 */
    network.options = [unlimited_selection, ...(targeting_dictionary?.network || [])];

    /** App 安装 */
    installation.options = [unlimited_selection, ...(targeting_dictionary?.installation || [])];
  }

  /**
   * 模块字段排序
   * @param {Object} fields
   * @returns {Object}
   */
  async setFieldsSort(fields) {
    const { campaign_config } = fields;
    const {
      daily_budget_type,
      daily_budget,
      price_type,
      auto_optimize,
      delivery_policy,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      skip_one_stage,
      price,
      convert_goal_price,
      ocpx_bid,
      deep_convert_price,
      deep_ocpx_bid,
      ...rest
    } = campaign_config.config.budget_and_bid_form.config;
    campaign_config.config.budget_and_bid_form.config = {
      daily_budget_type,
      daily_budget,
      price_type,
      auto_optimize,
      delivery_policy,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      skip_one_stage,
      price,
      convert_goal_price,
      ocpx_bid,
      deep_convert_price,
      deep_ocpx_bid,
      ...rest,
    };
    return Promise.resolve(fields);
  }

  /**
   * 设置动态渲染组件
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} payload 传递的数据，不限制键名和值
   */
  async setDynamicComponent(config, controller, payload) {
    if (config && controller && payload) {
      const { raw_ref_form_model, raw_form_model, form_assign_data } = payload;
      const is_campaign_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.delivery_form']?.campaign_type) !== JSON.stringify(raw_form_model['campaign_config.delivery_form']?.campaign_type);
      const is_site_sets_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_sets) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_sets);
      /**
       * 只要以下条件任意一个满足，则重新请求获取创意组件
       * is_campaign_type_changed 计划类型变更
       * is_site_sets_changed 版位变更
       */
      const valid = [is_campaign_type_changed, is_site_sets_changed].some(v => v);

      if (valid) {
        delete form_assign_data.creative_config;

        const {
          creative_config: {
            config: {
              content_form: {
                config: {
                  creative_template_id,
                },
              },
            },
          },
        } = config;

        const template_params = {
          filtering: {
            site_sets: raw_ref_form_model['campaign_config.site_form']?.site_sets,
            delivery_platform_type: raw_ref_form_model['campaign_config.delivery_form']?.delivery_platform_type,
          },
        };

        /** 获取创意规格选项 */
        creative_template_id.options = await controller.getCreativeTemplateList(template_params);
        creative_template_id.value = creative_template_id.options[0].value;
        creative_template_id.backup_value = creative_template_id.value;

        const params = {
          filtering: {
            site_sets: raw_ref_form_model['campaign_config.site_form']?.site_sets,
          },
          xiaomi_params: {
            filtering: {
              delivery_platform_type: raw_ref_form_model['campaign_config.delivery_form']?.delivery_platform_type,
              creative_template_id: creative_template_id.value,
            },
          },
        };

        await this.renderDynamicComponent({ config, params, controller });
      }
    }
  }

  /**
   * 渲染创意动态组件
   * @param {Object} data 配置项
   * @param {Object} data.config 模块表单配置
   * @param {Object} data.params 查询参数
   * @param {Object} data.controller 控制器
   * @param {string[]} data.creative_config_keys 创意配置键
   */
  async renderDynamicComponent({ config, params, controller }) {
    const {
      campaign_config: {
        config: {
          delivery_form,
        },
      },
      creative_config: {
        config: {
          content_form,
          creative_components,
        },
      },
      material_config: {
        config: {
          material_form,
        },
      },
    } = config;

    const { campaign_type } = delivery_form.config;
    const { fusion__customized_url, creative_template_id } = content_form.config;

    /**
     * 设置落地页跳转类型可见性
     * 如果创意形式为以下类型时，则可见且必填
     * - 大图：1
     * - 小图：2
     * - 组图：3
     * - 竖图：4
     * - 横版视频：5
     * - 竖版视频：6
     * - 开屏图片：7 (额外条件：计划类型为'商店'(campaign_type: 1))
     * @returns {void}
     */
    const setCustomizedUrlVisible = () => {
      const is_match = [1, 2, 3, 4, 5, 6].some((value) => creative_template_id.value === value);
      const is_open_screen = creative_template_id.value === 7;
      const is_store = campaign_type.value === 1;
      const is_open_screen_store = is_open_screen && is_store;
      fusion__customized_url.hidden = !(is_match || is_open_screen_store);
    };

    /**
     * 设置素材规格
     * @param {Object} config 动态组件配置项
     * @param {string[]} config.names 动态组件名称
     * @param {Object[]} config.list 动态组件列表
     * @returns {void}
     */
    const setMaterialSpec = ({ names = [], list = [] }) => {
      const { material } = material_form.config;
      const map_tuple = [
        /** 图片素材限制 */
        [
          () => names.includes('image'),
          () => {
            const image = list.find(item => item.name === 'image');
            const width = image?.restriction?.image_restriction?.width;
            const height = image?.restriction?.image_restriction?.height;
            const is_has_restriction = width && height;
            const is_image_list = image?.array_property?.max_number > 1;
            material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
            material.material_type = is_image_list ? 'element_story' : 'image';
            material.value.videos = [];
            material.value.tab = 'image';
          },
        ],
        /** 视频素材限制 */
        [
          () => names.includes('video'),
          () => {
            const video = list.find(item => item.name === 'video');
            const width = video?.restriction?.video_restriction?.min_width;
            const height = video?.restriction?.video_restriction?.min_height;
            const is_has_restriction = width && height;
            material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
            material.material_type = 'video';
            material.value.images = [];
            material.value.tab = 'video';
          },
        ],
        /** 不限制素材 */
        [
          () => !names.includes('video') && !names.includes('image'),
          () => {
            material.materialRestriction = [];
            material.material_type = null;
            material.value.tab = 'video';
          },
        ],
      ];
      map_tuple.forEach(([condition, handler]) => (condition() && handler()));
    };

    /**
     * 生成动态创意组件
     * @param {Object} config 动态组件配置项
     * @param {string[]} config.names 动态组件名称
     * @param {Object[]} config.list 动态组件列表
     * @returns {void}
     */
    const generateDynamicComponent = ({ names = [], list = [] }) => {
      creative_components.config = clone(creative_components_config);

      const dynamic_component_keys = [
        'description',
        'product_description',
        'brand',
        'deep_link_url',
      ];

      [creative_components].forEach(target => {
        Object.keys(target.config).forEach(key => {
          if (!names.includes(key) && dynamic_component_keys.includes(key)) {
            delete target.config[key];
          }
        });
        const ret = list.filter(item => target.config[item.name]);
        list.forEach((item) => Object.assign(item, { element_type: target.config[item.name]?.type, default_value: target.config[item.name]?.default_value }));
        target.config = deepMerge([target.config, generateDynamicFormModel(ret)]);
      });

      this.addEvent(config, controller);
    };

    try {
      setCustomizedUrlVisible();
      creative_components.loading = true;
      const config = await controller.getDynamicComponent(params);
      generateDynamicComponent(config);
      setMaterialSpec(config);
    } catch (error) {
      console.error(error);
    } finally {
      creative_components.loading = false;
    }
  }

  /**
   * 转换差异化广告预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   */
  transformDifferentiatedCampaignPreviewPayload({ form_assign_data }) {
    const {
      campaign_config: {
        delivery_form: {
          campaign_type,
        },
        site_form: {
          traffic_mode,
        },
        schedule_form: {
          time_period_type,
          schedule_time,
          time_period,
        },
        budget_and_bid_form: {
          auto_optimize,
          delivery_policy,
          skip_one_stage,
          convert_goal_price,
          ocpx_bid,
          deep_ocpx_bid,
          fusion__optimize_goal,
          deep_convert_type,
        },
      },
    } = form_assign_data;

    return {
      /** 计划类型 */
      ...(campaign_type && { campaign_type }),
      /** 流量优选 */
      ...(isNotNullAndUnDef(traffic_mode) && { traffic_mode }),
      /** 投放时间类型 */
      ...(time_period_type && { time_period_type }),
      /** 投放时间 - 全天 */
      ...(time_period_type === 'TIME_PERIOD_ALL' && { time_period: new Array(TIME_PERIOD_LENGTH.HALF_HOUR).fill(1).join('') }),
      /** 投放时间 - 指定时间 */
      ...(time_period_type === 'TIME_PERIOD_DAY_SPECIFIC' && { time_period: transformSelectedTimeToTimeSeries(schedule_time.start, schedule_time.end) }),
      /** 投放时间 - 指定多个时间 */
      ...(time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC' && { time_period: time_period.schedule_time_content }),
      /** 自动优化 */
      ...(isNotNullAndUnDef(auto_optimize) && { auto_optimize }),
      /** 投放类型 */
      ...(isNotNullAndUnDef(delivery_policy) && { delivery_policy }),
      /** 优化目标 */
      ...(fusion__optimize_goal && { convert_goal: fusion__optimize_goal }),
      /** 深度优化目标 */
      ...(deep_convert_type && { deep_convert_goal: deep_convert_type }),
      /** 广告免一阶 */
      ...(isNotNullAndUnDef(skip_one_stage) && { skip_one_stage }),
      /** 优化目标出价 */
      ...(convert_goal_price && { convert_goal_price: calculator.times(convert_goal_price, 100) }),
      /** 优化 ROI 系数出价 */
      ...(ocpx_bid && { ocpx_bid }),
      /** 深度 ROI 系数出价 */
      ...(deep_ocpx_bid && { deep_ocpx_bid }),
    };
  }

  /**
   * 转换差异化创意预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   * @returns {Object}
   */
  transformDifferentiatedCreativePreviewPayload({ form_assign_data }) {
    const {
      creative_config: {
        content_form: {
          creative_template_id,
        } = {},
        creative_components: {
          description,
          product_description,
          brand,
          deep_link_url,
        } = {},
      },
    } = form_assign_data;

    return {
      /** 创意规格ID */
      creative_template_id,
      /** 广告描述 */
      ...(description && { description }),
      /** 推广产品描述 */
      ...(product_description && { product_description }),
      /** 广告品牌描述 */
      ...(brand && { brand }),
      /** DeepLink地址 */
      ...(deep_link_url && { deep_link_url }),
    };
  }

  /**
   * 获取创建定向包差异化接口参数
   * @param {Object} target_data 定向数据
   * @returns {Object}
   */
  getDifferentiatedCreateTargetParams(target_data) {
    const {
      age: {
        age_selection,
        age,
      },
      network,
      installation,
    } = target_data;

    const target_params = {
      [`${CHANNEL_INTERFACE_TYPE.XIAOMI}_params`]: {
        /** 年龄 */
        ...(age_selection === OPTIONS_TYPE.CUSTOM && { age }),
        /** 网络环境 */
        ...(!network.includes(OPTIONS_TYPE.UNLIMITED) && { network }),
        /** App 安装 */
        ...(!installation.includes(OPTIONS_TYPE.UNLIMITED) && { installation }),
      },
    };

    return target_params;
  }

  /**
   * 获取定向包差异化详情表单数据
   * @param {Object} target_params 定向详情数据
   * @returns {Object}
   */
  getDifferentiatedTargetDetailFormData(target_params) {
    const {
      [`${CHANNEL_INTERFACE_TYPE.XIAOMI}_params`]: {
        age,
        network,
        installation,
      } = {},
    } = target_params;

    const form_data = {
      /** 年龄 */
      ...(age && {
        age: {
          age_selection: OPTIONS_TYPE.CUSTOM,
          age,
        },
      }),
      /** 网络环境 */
      ...(network && { network }),
      /** App 安装 */
      ...(installation && { installation }),
    };
    return form_data;
  }

  /**
   * 获取定向数据转预览数据关联表
   * @returns {Object}
   */
  getTargetPreviewAssociatedMap() {
    return {
      age_selection: {
        associated_keys: ['age'],
      },
    };
  }

  /**
   * 获取素材属性
   * @param {Object} material_config 素材表单配置
   * @returns {Object}
   */
  getMaterialProps(material_config) {
    const { materialRestriction, material_type } = material_config?.config?.material_form?.config?.material;
    return {
      materialRestriction,
      ...(material_type && { type: material_type }),
    };
  }

  /**
   * 设置源数据表单
   * @param {Object} source 源数据
   * @param {Object} target 目标数据
   * @returns {void}
   */
  setSourceFormFieldsData(source, target) {
    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material,
            },
          },
        },
      },
    } = source;

    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material: target_material,
            },
          },
        },
      },
    } = target;

    material.value.images.splice(0);
    material.value.images.push(...target_material.value.images);
    material.value.videos.splice(0);
    material.value.videos.push(...target_material.value.videos);
    material.value.tab = target_material.value.tab;

    Object.assign(material, {
      materialRestriction: target_material.materialRestriction,
      material_type: target_material.material_type,
    });
  }

  /**
   * 获取差异化模板配置表
   * @returns {Object}
   */
  getDifferentiatedTemplateMap() {
    return {
      campaign_config: {
        delivery_form: ['campaign_type'],
        budget_and_bid_form: [
          'auto_optimize',
          'delivery_policy',
          'skip_one_stage',
        ],
      },
      creative_config: {
        content_form: [
          'delivery_mode',
          'creative_template_id',
          'fusion__customized_url',
        ],
      },
    };
  }

  /**
   * 是否重新渲染动态创意
   * @param {Object} old_campaign_config 旧广告配置
   * @param {Object} new_campaign_config 新广告配置
   * @returns {Boolean}
   */
  isReRenderCreative(old_campaign_config, new_campaign_config) {
    const {
      delivery_form: {
        config: {
          campaign_type: old_campaign_type,
        },
      },
      site_form: {
        config: {
          site_sets: old_site_sets,
        },
      },
    } = old_campaign_config.config;

    const {
      delivery_form: {
        config: {
          campaign_type: new_campaign_type,
        },
      },
      site_form: {
        config: {
          site_sets: new_site_sets,
        },
      },
    } = new_campaign_config.config;

    const is_campaign_type_changed = JSON.stringify(old_campaign_type.value) !== JSON.stringify(new_campaign_type.value);
    const is_site_sets_changed = JSON.stringify(old_site_sets.value) !== JSON.stringify(new_site_sets.value);
    /**
     * 只要以下条件任意一个满足，则重新请求获取创意组件
     * is_campaign_type_changed 计划类型变更
     * is_site_sets_changed 版位变更
     */
    const valid = [is_campaign_type_changed, is_site_sets_changed].some(v => v);

    return valid;
  }

  /**
   * 是否显示预览按钮
   * @param {Object} form_assign_data 分配数据
   * @returns {boolean}
   */
  isShowPreviewBtn(form_assign_data) {
    const all_keys = [CAMPAIGN_MODULE_KEY, CREATIVE_MODULE_KEY, TARGETING_MODULE_KEY];
    const is_has_all_kays = all_keys.every(key => !!form_assign_data[key]);
    if (!is_has_all_kays) {
      return false;
    }

    const {
      campaign_config: {
        site_form: {
          site_sets,
        },
      },
      creative_config: {
        content_form: {
          creative_template_id,
        },
      },
    } = form_assign_data;

    /**
     * 1、当创意形式为指定类型时，素材配置为'选填'，即无需配置素材的情况下允许提交预览
     * - 应用信息: 11
     * - 图标: 9
     */
    const is_not_support_material = [9, 11].includes(creative_template_id);

    /**
     * 1、当创意形式为指定类型时，标题配置为'选填'，即无需配置标题的情况下允许提交预览
     * - 应用信息: 11
     * - 开屏图片: 7
     * - 大图: 1 (额外条件：广告版位为商店-富媒体: '34')
     * - 竖图: 4
     * - 开屏视频: 8
     */
    const is_not_support_titles = [4, 7, 8, 11].includes(creative_template_id) || ['34'].includes(site_sets[0]) && [1].includes(creative_template_id);

    /** 素材数据 */
    const material = form_assign_data[MATERIAL_MODULE_KEY];

    /**
     * 是否存在素材
     * 如果创意形式为指定类型时，跳过校验规则，返回true
     */
    const is_has_material = is_not_support_material ? true : (material?.images?.length > 0 || material?.videos?.length > 0);

    /**
     * 需要检验的基础模块的key
     * - 广告信息模块
     * - 创意信息模块
     */
    const basic_keys = [CAMPAIGN_MODULE_KEY, CREATIVE_MODULE_KEY];

    /**
     * 需要检验的分配模块的key
     * - 定向信息模块
     * - 标题信息模块，当创意形式为指定类型时(具体看is_not_support_titles判断逻辑)，跳过校验规则
     * - 小米渠道不支持落地页模块配置，所以不参与校验
     */
    const assign_keys = [
      TARGETING_MODULE_KEY,
      ...(is_not_support_titles ? [] : [TITLE_MODULE_KEY]),
    ];

    return basic_keys.every(key => !!form_assign_data[key]) && assign_keys.every(key => form_assign_data[key]?.length > 0) && is_has_material;
  }
}
